import React from 'react';
import { useStore } from 'effector-react';
import TextLink from '@components/TextLink';
import { $sceneMapApi } from '@stores/dataStores';
import { $loadedScene } from '@stores/loadedStore';
import { showConfirmModal } from '@components/ConfirmModal';
import { krpRemoveCustomRotate } from '../actions/krpRotate';

export function RotateClear() {
  const scene = useStore($loadedScene)!;
  const list = scene.config.autoRotate?.tourData ?? [];

  const handleClear = async () => {
    const { confirmed } = await showConfirmModal({
      title: '确认操作',
      content: (
        <>
          <div className="text-xl">确认清空导览节点吗？</div>
          <div className="mt-10">所有节点都会被清空，并且无法找回。</div>
        </>
      ),
    });
    if (!confirmed) return;
    krpRemoveCustomRotate({ withoutStart: true });
    $sceneMapApi.updateScene({
      id: scene.id,
      updater: (draft) => {
        draft.config.autoRotate!.tourData = [];
      },
    });
  };
  return (
    <TextLink
      className="mt-2 text-sm"
      disabled={!list.length}
      onClick={handleClear}
    >
      清空
    </TextLink>
  );
}
